<ion-content>
  <ion-grid>
    <ion-row class="cookie-consent-info">
      <ion-col size="12" class="popup-header"
        ><div><h3>Cookies on Cloudia 🍪</h3></div></ion-col
      >
      <ion-col size="12" class="description"
        ><div>
          <p>We use some essential cookies to make Cloudia work.</p>
        </div></ion-col
      >
      <ion-col size="12" class="description"
        ><div>
          <p>
            We’d like to set additional cookies to understand how you use
            Cloudia so that we can adjust and provide you with better user
            experience. We don’t use any marketing cookies.
          </p>
        </div></ion-col
      >
      <ion-col size="12" class="description"
        ><div>
          <p>
            You can always change your cookie settings via our Cookie policy
            page or in Cloudia settings.
          </p>
        </div></ion-col
      >
      <ion-col size="12" class="button-wrapper" style="padding-bottom: 0"
        ><ion-button id="accept-cookies" (click)="acceptAllCookies($event)"
          >Accept cookies</ion-button
        ></ion-col
      >
      <ion-col size="12" class="button-wrapper"
        ><ion-button id="view-settings" (click)="viewCookieSettings($event)"
          >View cookies settings</ion-button
        ></ion-col
      >
    </ion-row>
  </ion-grid>
</ion-content>
